import { buildImgSrc } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { Icon, Image, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
`

const Element = styled(Image.Root)`
  height: 100%;
  object-fit: cover;
  width: 100%;

  img {
    filter: unset;
  }
`

interface DetailImageProps {
  src: string
  alt: string
  inView?: boolean
}

export function DetailImage({ src, alt, inView }: DetailImageProps) {
  const intl = useIntl()

  return (
    <Wrapper>
      <Element
        defaultSource={{
          src: buildImgSrc(src, 480, 360),
          width: 480,
          height: 360,
        }}
        loaderSource={{ src: buildImgSrc(src, 20) }}
        sources={[
          {
            src: buildImgSrc(src, 1280, 960),
            width: 1280,
            height: 960,
            breakpoint: 'breakpoint_tablet',
          },
        ]}
        alternativeText={alt || ''}
        startImmediateLoad={inView}
      >
        <Image.Error>
          <Icon glyph="IconNoImage" size="lg" />
          <Typography $variant="body-lg-bold">{intl.formatMessage({ id: 'no_image' })}</Typography>
        </Image.Error>
      </Element>
    </Wrapper>
  )
}
